import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import 'whatwg-fetch'
import { MsAuthSupport } from './ms-auth-support'
import { loadEnv } from 'core/actions'
// import { loadAnalyticsEnvironment } from 'analytics/actions'
// import { InitError } from '@integec/common-react-screens/lib/common-components'
import InitError from './InitError'
// import { registerWindowResize } from '@integec/common-react-screens/lib/utils'
import { fromNullable } from 'data.maybe'
// require('!!style-loader!css-loader!rc-tree/assets/index.css')
// import '!!style-loader!css-loader!rc-tree/assets/index.css'
import './css/context-menu.css'
import './css/react-resizable.css'
import './css/custom.css'
import './css/antd-update.css'

import 'react-toggle/style.css'
// import Dashboard from './Dashboard'
import { getMetaConfig, getEffectiveJwt, JWT_KEY } from './utils'
// import 'react-month-picker/css/month-picker.css'
/* eslint-disable import/no-unresolved */
require('normalize.css/normalize.css')
// require('!!style-loader!css-loader!@integec/common-react-screens/styles/date-picker.css')
// require('!!style-loader!css-loader!antd/dist/antd.css')
/* eslint-enable import/no-unresolved */

const rootEl = document.getElementById('root')

/*eslint-disable*/
console.log('apiMode', apiMode)

const derivedHost = fromNullable(window)
  .chain(w => fromNullable(w.location))
  .chain(l => fromNullable(l.host))
  .map(h => h.substr(0, h.indexOf('.')) + '-api' + h.substr(h.indexOf('.')))
  .getOrElse('localhost:9797')

const derivedProtocol = fromNullable(window)
  .chain(w => fromNullable(w.location))
  .chain(l => fromNullable(l.protocol))
  .getOrElse('http:')

const server = getMetaConfig(
  'apiServer',
  `${derivedProtocol}//${derivedHost}/api`
)

const initialState = {
  core: {
    apiTargetInfo: {
      baseUrl: apiMode === 'prod' ? `${server}` : 'http://localhost:9797/api',
      jwt: getEffectiveJwt(),
      fetchCredentials: getMetaConfig('fetchTaskCredentials'),
    },
  },
}

const development =
  process.env.NODE_ENV === undefined || process.env.NODE_ENV !== 'production'
const basename = development ? undefined : '/pgads'
// if (development) console.log('initial state is: ', initialState)
/* eslint-enable */

const store = configureStore(initialState)

// registerWindowResize({ store, actionName: 'core@@WINDOW_SIZE_CHANGE' })

const renderApp = (Content, element) => {
  ReactDOM.render(
    <MsAuthSupport>
      <div style={{ backgroundColor: '#f0f2f5' }}>
        <AppContainer>
          <Provider store={store}>
            <Content />
          </Provider>
        </AppContainer>
      </div>
    </MsAuthSupport>,
    element
  )
}

const loadApp = () => renderApp(require('./Dashboard.js').default, rootEl)
const displayError = e => {
  console.log(e)
  ReactDOM.render(<InitError jwtKey={JWT_KEY} modalInfo={e} />, rootEl)
}

loadApp()

// store.dispatch(loadAnalyticsEnvironment())
store.dispatch(loadEnv(displayError, loadApp))

if (module.hot) {
  module.hot.accept('./Dashboard.js', () => {
    loadApp()
  })
}
